import { render } from "./balance2.vue?vue&type=template&id=2966de63&scoped=true"
import script from "./balance2.vue?vue&type=script&lang=js"
export * from "./balance2.vue?vue&type=script&lang=js"

import "./balance2.vue?vue&type=style&index=0&id=2966de63&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2966de63"]])

export default __exports__